import React from 'react'
import { Button, Header, Icon, Table, Divider } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

const ArticleLinks = props => {
  const { links, objId, detail } = props
  if (links === null) {
    return (
      <div>
        Aucun enregistrement
        <Button as={ Link } name='new' to={`/events/${objId}/links/${detail.getArticleDetail.id}/new`} floated="right" icon labelPosition="left" color="olive" size="small">
          <Icon name="chain" /> Ajouter un lien
        </Button>
      </div>
    )
  }
  return (
    <div>
      {
        detail.loading ? <Header as="h1">Liens</Header> :
          <Header as="h1">Liens de "<Link name='event' to={`/blog/articles/${objId}`}>{detail.getArticleDetail.title}</Link>"</Header>
      }
      <Table selectable singleLine color="red">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Libellé</Table.HeaderCell>
            <Table.HeaderCell>Adresse web</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {links.map((link) => {
            return (
              <Table.Row key={link.id}>
                <Table.Cell>
                  <Link as="a" name="link" to={`/blog/articles/${objId}/links/${detail.getArticleDetail.id}/${link.id}`}>
                    {link.text}
                  </Link>
                </Table.Cell>
                <Table.Cell>
                  <a href={link.url}>{link.url}</a>
                </Table.Cell>
              </Table.Row>
            )
          })}
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan="4">
              <Button as={ Link } name='new' to={`/blog/articles/${objId}/links/${detail.getArticleDetail.id}/new`} floated="right" icon labelPosition="left" color="olive" size="small">
                <Icon name="chain" /> Ajouter un lien
              </Button>
              <Divider hidden={true} />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </div>
  )
}

export default ArticleLinks



// WEBPACK FOOTER //
// ./src/components/list/ArticleLinks.js